import React, { useEffect } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { createBusinessType, updateBusinessType } from "./Helper";

const BusinessTypeUpdate = () => {
  const location = useLocation();
  const context = useOutletContext();
  const id = location.state?.id == null ? null : location?.state?.id;
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type: location.state?.type,
    },
  });

  useEffect(()=>{
    context(["Business Types", id == null ? "Add Business Type" : "Update Business Type"])
  },[])

  const submit = (formData) => {
    if (id == null) {
      createBusinessType({ type: formData?.type })
        .then((data) => {
          console.log(data.data);
          navigate("/BusinessType");
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      updateBusinessType({ id: id, type: formData?.type })
        .then((data) => {
          console.log(data.data);
          navigate("/BusinessType");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  return (
    <div className="p-5 shadow-md bg-white">
      <div className="grid grid-cols-6 gap-2">
        <h3
          className="col-span-5 text-lg uppercase tracking-wider font-bold"
          style={{ color: "#2EBAA3" }}
        >
          {id == null ? "Create" : "Update"} Business Type
        </h3>
      </div>
      <br />
      <div class="overflow-x-auto relative ">
        <form onSubmit={handleSubmit((data) => submit(data))}>
          <div className="w-80 pt-2">
            <TextField
              id="outlined-basic"
              {...register("type", { required: true })}
              label="Business Type *"
              margin="normal"
              variant="outlined"
              size="small"
              fullWidth
            />
            {errors.type && (
              <p className="text-red-500 text-xs">Business Type is required</p>
            )}
          </div>
          <div className="text-right pt-10">
            <Button
              type="submit"
              variant="contained"
              style={{ color: "white" }}
            >
              {id == null ? "Add" : "Update"} Business Type
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BusinessTypeUpdate;
